import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrintLayoutComponent } from 'src/app/ui/print-layout/print-layout.component';
import { PrintLayoutSectionComponent } from 'src/app/ui/print-layout/print-layout-section.component';

export interface NotePrintVm {
  siteLabel: string;
  userLabel: string;
  dateLabel: string;
  roomLabel: string;
  siteName: string;
  username: string;
  formattedDate: string;
  room?: string | null;
  text?: string | null;
}

@Component({
  selector: 'app-note-print',
  standalone: true,
  imports: [
    CommonModule,
    PrintLayoutComponent,
    PrintLayoutSectionComponent,
  ],
  templateUrl: './note-print.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './note-print.component.scss',
})
export class NotePrintComponent {
  vm = input.required<NotePrintVm>();
  printId = input('print-note');
  visible = input(true);
  readonly summaryItems = computed(() => {
    const vm = this.vm();
    return [
      { label: vm.siteLabel, value: vm.siteName },
      { label: vm.userLabel, value: vm.username },
      { label: vm.dateLabel, value: vm.formattedDate },
    ];
  });
}
